/* ==========================================================
   REDISEÑO VAGONES DE SONRISAS — comportamiento (22 oct 2026)
   Se carga en todas las páginas menos las landings.
   Sin GSAP todo se ve igual, solo que sin animaciones.
   En el personalizador cada sección se vuelve a iniciar al editarla.
   ========================================================== */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var qa = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* Barra de anuncios: rota sola y con flechas */
  function annc(root) {
    qa(root, '[data-vh-annc]').forEach(function (bar) {
      if (bar.vhDone) return; bar.vhDone = true;
      var msgs = qa(bar, '.vh-annc__msg'), i = 0, t;
      if (msgs.length < 2) return;
      var show = function (n) { msgs[i].classList.remove('is-on'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-on'); };
      var loop = function () { clearInterval(t); t = setInterval(function () { show(i + 1); }, 4500); };
      bar.querySelector('[data-vh-prev]').addEventListener('click', function () { show(i - 1); loop(); });
      bar.querySelector('[data-vh-next]').addEventListener('click', function () { show(i + 1); loop(); });
      loop();
    });
  }

  /* Header: menús desplegables y menú de celular */
  function header(root) {
    qa(root, '.vh-nav__item[data-vh-drop]').forEach(function (item) {
      if (item.vhDone) return; item.vhDone = true;
      var btn = item.querySelector('.vh-nav__link');
      var set = function (on) {
        qa(document, '.vh-nav__item.is-open').forEach(function (o) { if (o !== item) { o.classList.remove('is-open'); o.querySelector('.vh-nav__link').setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      item.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) set(true); });
      item.addEventListener('mouseleave', function () { set(false); });
      btn.addEventListener('click', function () { set(!item.classList.contains('is-open')); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { set(false); btn.focus(); } });
    });
    if (!window.vhOutside) {
      window.vhOutside = true;
      document.addEventListener('click', function (e) {
        qa(document, '.vh-nav__item.is-open').forEach(function (o) { if (!o.contains(e.target)) { o.classList.remove('is-open'); o.querySelector('.vh-nav__link').setAttribute('aria-expanded', 'false'); } });
      });
    }
    var sheet = document.getElementById('vh-sheet');
    qa(root, '[data-vh-burger]').forEach(function (b) {
      if (b.vhDone || !sheet) return; b.vhDone = true;
      b.addEventListener('click', function () { sheet.hidden = false; document.documentElement.style.overflow = 'hidden'; var c = sheet.querySelector('[data-vh-close]'); if (c) c.focus(); });
    });
    if (sheet && !sheet.vhDone) {
      sheet.vhDone = true;
      var close = function () { sheet.hidden = true; document.documentElement.style.overflow = ''; };
      sheet.querySelector('[data-vh-close]').addEventListener('click', close);
      sheet.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      qa(sheet, '[data-vh-stab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var k = tab.getAttribute('data-vh-stab');
          qa(sheet, '[data-vh-stab]').forEach(function (o) { var on = o === tab; o.classList.toggle('is-on', on); o.setAttribute('aria-selected', on ? 'true' : 'false'); });
          qa(sheet, '[data-vh-slist]').forEach(function (l) { l.hidden = l.getAttribute('data-vh-slist') !== k; });
        });
      });
      qa(sheet, 'a').forEach(function (a) { a.addEventListener('click', close); });
    }
  }

  /* Hero: video siempre sin sonido; se repite solo el tramo elegido.
     23 oct 2026: celular baja 480p y computador 720p (antes 1080p). */
  function hero(root) {
    qa(root, '[data-vh-hero-video]').forEach(function (v) {
      if (v.vhDone) return; v.vhDone = true;
      var a = parseFloat(v.getAttribute('data-start')) || 0, b = parseFloat(v.getAttribute('data-end')) || 0;
      v.muted = true; v.volume = 0;
      /* El video queda invisible (se ve la foto) hasta que ya está en el tramo elegido,
         así nunca se ven los primeros segundos (23 oct 2026). #t= le pide al navegador
         empezar ahí y no descargar el principio. */
      var frag = a > 0 ? '#t=' + a : '';
      var src = window.innerWidth < 900 ? v.getAttribute('data-sd') : v.getAttribute('data-hd');
      var orig = v.getAttribute('data-orig');
      function play() { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
      function enTramo() { return v.currentTime >= a - .3 && (b <= a || v.currentTime < b); }
      v.style.opacity = '0'; v.style.transition = 'opacity .6s ease';
      if (orig) v.addEventListener('error', function () { if (v.src.indexOf(orig) < 0) { v.src = orig + frag; play(); } });
      if (src && !v.getAttribute('src')) { v.preload = 'auto'; v.src = src + frag; }
      v.addEventListener('loadedmetadata', function () { if (a > 0 && v.currentTime < a - .3) v.currentTime = a; });
      v.addEventListener('timeupdate', function () {
        if ((b > a && v.currentTime >= b) || v.currentTime < a - .3) { v.currentTime = a; return; }
        if (enTramo()) v.style.opacity = '1';
      });
      if (b > a) v.loop = false;
      v.addEventListener('ended', function () { v.currentTime = a; play(); });
      play();
    });
  }

  /* Catálogo por edades: pestañas y tarjetas que se vuelven a inflar */
  function catalogo(root) {
    qa(root, '[data-vh-tabs]').forEach(function (box) {
      if (box.vhDone) return; box.vhDone = true;
      var tabs = qa(box, '[data-vh-tab]'), panels = qa(box, '[data-vh-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var k = tab.getAttribute('data-vh-tab');
          tabs.forEach(function (o) { var on = o === tab; o.classList.toggle('is-on', on); o.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-vh-panel') === k; p.hidden = !on;
            if (on && window.gsap && !reduce) gsap.fromTo(p.querySelectorAll('.vh-pcard'), { scale: .84, opacity: 0, y: 24 }, { scale: 1, opacity: 1, y: 0, duration: 1, ease: 'elastic.out(1, .65)', stagger: .06 });
          });
        });
      });
    });
  }

  /* Videos de clientes: suenan solo al darles play, uno a la vez */
  function reels(root) {
    qa(root, '.vh-reel').forEach(function (r) {
      if (r.vhDone) return; r.vhDone = true;
      var v = r.querySelector('video'), b = r.querySelector('.vh-reel__play');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        qa(document, '.vh-reel video').forEach(function (o) { if (o !== v) o.pause(); });
        b.hidden = true; v.controls = true; v.muted = false;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }

  /* Video destacado: suena solo al darle play */
  function vframe(root) {
    qa(root, '[data-vh-vframe]').forEach(function (f) {
      if (f.vhDone) return; f.vhDone = true;
      var v = f.querySelector('video'), b = f.querySelector('.vh-vframe__play');
      if (!v || !b) return;
      b.addEventListener('click', function () { b.hidden = true; v.controls = true; v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    });
  }

  /* Portada con "Ver video": abre el video encima de la página */
  function portada(root) {
    qa(root, '[data-vh-open]').forEach(function (btn) {
      if (btn.vhDone) return; btn.vhDone = true;
      var modal = document.getElementById(btn.getAttribute('data-vh-open'));
      if (!modal) return;
      var v = modal.querySelector('video'), close = modal.querySelector('[data-vh-close-modal]');
      var cerrar = function () { if (v) v.pause(); modal.hidden = true; document.documentElement.style.overflow = ''; btn.focus(); };
      btn.addEventListener('click', function () {
        if (v && !v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
        modal.hidden = false; document.documentElement.style.overflow = 'hidden';
        if (close) close.focus();
        if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      if (close) close.addEventListener('click', cerrar);
      modal.addEventListener('click', function (e) { if (e.target === modal) cerrar(); });
      modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
    });
  }

  /* Ficha de inflable: miniaturas que mueven la galería */
  function ficha(root) {
    qa(root, '[data-vh-ficha]').forEach(function (f) {
      if (f.vhDone) return; f.vhDone = true;
      /* Ficha técnica (30 oct 2026): las medidas se leen de la descripción, p. ej. "9m (ancho) x 9m (largo) x 8m (alto)" */
      var desc = f.querySelector('[data-vh-desc]'), med = f.querySelector('[data-vh-med]');
      if (desc && med) {
        var re = /(\d+(?:[.,]\d+)?)\s*m(?:ts|etros)?\.?\s*\(\s*(ancho|largo|alto)\s*\)/gi, m, nums = [], dims = [];
        while ((m = re.exec(desc.textContent)) && nums.length < 3) { nums.push(m[1].replace('.', ',')); dims.push(m[2].toLowerCase()); }
        if (nums.length >= 2) {
          med.querySelector('dd').textContent = nums.join(' × ') + ' m (' + dims.join(', ') + ')'; med.hidden = false;
          /* Las medidas ya salen en la ficha técnica: se quita de "La historia" la frase que las dice (pedido del 30 oct 2026) */
          var tiene = /\d\s*m(?:ts|etros)?\.?\s*\(\s*(?:ancho|largo|alto)\s*\)/i, w = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT), nodos = [], n;
          /* Igual con la línea "Edad: …", que ya sale en la fila Edad */
          var edad = /^\s*edad\s*:/i;
          while ((n = w.nextNode())) if (tiene.test(n.nodeValue) || edad.test(n.nodeValue)) nodos.push(n);
          nodos.forEach(function (t) {
            var frases = edad.test(t.nodeValue) ? [] : (t.nodeValue.match(/[^.!?…]+[.!?…]*\s*/g) || []);
            t.nodeValue = frases.filter(function (fr) { return !tiene.test(fr); }).join('').replace(/\s+$/, '');
            var p = t.parentNode; if (p && p !== desc && !p.textContent.trim()) p.parentNode.removeChild(p);
          });
        }
      }
      var track = f.querySelector('.vh-pr__track'), thumbs = qa(f, '.vh-pr__thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var slide = document.getElementById(t.getAttribute('data-vh-slide'));
          if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          thumbs.forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Preguntas frecuentes */
  function faq(root) {
    qa(root, '.vh-fq__q').forEach(function (q) {
      if (q.vhDone) return; q.vhDone = true;
      q.addEventListener('click', function () {
        var item = q.parentNode, a = item.querySelector('.vh-fq__a'), on = !item.classList.contains('is-open');
        item.classList.toggle('is-open', on); q.setAttribute('aria-expanded', on ? 'true' : 'false'); a.hidden = !on;
      });
    });
  }

  /* Animaciones con GSAP */
  function motion(root) {
    var g = window.gsap, ST = window.ScrollTrigger;
    if (!g || !ST || reduce) return;
    g.registerPlugin(ST);
    var one = function (sel) { return root.querySelector(sel); };
    // Hero: entrada y profundidad
    qa(root, '.vh-hero, .vh-ph').forEach(function (h) {
      g.from(h.querySelectorAll('.vh-hero__h .vh-ln > span'), { yPercent: 110, duration: 1.1, stagger: .1, ease: 'power4.out', delay: .15 });
      g.from(h.querySelectorAll('.vh-hero-in'), { y: 24, opacity: 0, duration: .9, stagger: .08, ease: 'power3.out', delay: .45 });
      var m = h.querySelector('.vh-hero__media, .vh-ph__media'), c = h.querySelector('.vh-hero__copy');
      if (m) g.to(m, { scale: 1.12, ease: 'none', scrollTrigger: { trigger: h, start: 'top top', end: 'bottom top', scrub: true } });
      if (c) g.to(c, { y: -70, opacity: .25, ease: 'none', scrollTrigger: { trigger: h, start: '35% top', end: 'bottom top', scrub: true } });
    });
    // Titulares: cada línea sube desde su máscara
    qa(root, '.vh-rv').forEach(function (h) {
      g.from(h.querySelectorAll('.vh-ln > span'), { yPercent: 110, duration: 1, stagger: .09, ease: 'power4.out', scrollTrigger: { trigger: h, start: 'top 85%' } });
    });
    // Tarjetas que se inflan con rebote
    qa(root, '.vh-puff').forEach(function (el, i) {
      g.from(el, { scale: .84, opacity: 0, duration: 1.2, ease: 'elastic.out(1, .6)', delay: (i % 3) * .08, scrollTrigger: { trigger: el, start: 'top 90%' } });
    });
    qa(root, '[data-vh-panel]:not([hidden])').forEach(function (p) {
      g.from(p.querySelectorAll('.vh-pcard'), { scale: .84, opacity: 0, y: 30, duration: 1.1, ease: 'elastic.out(1, .65)', stagger: .07, scrollTrigger: { trigger: p, start: 'top 85%' } });
    });
    // Fotos que se mueven más lento que la página
    qa(root, '[data-vh-par]').forEach(function (img) {
      g.fromTo(img, { yPercent: -6 }, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: img.parentNode, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    // Ready: los inflables entran de lado
    qa(root, '.vh-rd').forEach(function (s) {
      var img = s.querySelector('.vh-rd__img');
      if (img) g.from(img, { x: 160, rotate: 4, opacity: 0, duration: 1.4, ease: 'power4.out', scrollTrigger: { trigger: s, start: 'top 65%' } });
      g.from(s.querySelectorAll('.vh-rd__chip'), { y: 20, opacity: 0, duration: .6, stagger: .05, ease: 'power3.out', scrollTrigger: { trigger: s, start: 'top 50%' } });
    });
    // Cifras: cada número se infla como un globo mientras cuenta
    qa(root, '.vh-puffnum').forEach(function (n, i) {
      g.from(n, { scale: .2, opacity: 0, duration: 1.5, ease: 'elastic.out(1, .45)', delay: (i % 4) * .12, scrollTrigger: { trigger: n, start: 'top 88%' } });
    });
    qa(root, '[data-vh-to]').forEach(function (el) {
      var to = parseInt(el.getAttribute('data-vh-to'), 10), o = { v: 0 };
      if (!to) return;
      g.to(o, { v: to, duration: 2, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 88%' }, onUpdate: function () { el.textContent = Math.round(o.v).toLocaleString('es-CO'); } });
    });
    // Sello giratorio
    qa(root, '[data-vh-spin]').forEach(function (s) { g.to(s, { rotate: 360, duration: 18, repeat: -1, ease: 'none', transformOrigin: '50% 50%' }); });
    setTimeout(function () { ST.refresh(); }, 500);
  }

  function init(root) {
    [annc, header, hero, catalogo, reels, vframe, portada, ficha, faq, motion].forEach(function (fn) { try { fn(root); } catch (e) { console.error('[vh]', e); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('load', function () { if (window.ScrollTrigger) ScrollTrigger.refresh(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* Editor de temas: al escoger un bloque del menú en vista de celular, se abre la hoja para verlo (30 oct 2026) */
  document.addEventListener('shopify:block:select', function (e) {
    var b = document.querySelector('[data-vh-burger]'), sheet = document.getElementById('vh-sheet');
    if (b && sheet && e.target.closest && e.target.closest('.vh-hdr') && b.offsetParent !== null) { sheet.hidden = false; }
  });
  document.addEventListener('shopify:section:deselect', function () { var sheet = document.getElementById('vh-sheet'); if (sheet && window.Shopify && Shopify.designMode) { sheet.hidden = true; document.documentElement.style.overflow = ''; } });
})();
